import DefaultMenu from "./default/DefaultMenu";

// Şube-bazlı menü teması registry'si. branch.settings.theme bu anahtarlardan birine
// eşlenir; bilinmeyen/boş anahtar 'default'a düşer. Yeni tasarım = bir bileşen + burada
// bir satır (büyük tasarımlarda lazy(): const Modern = lazy(() => import('./modern/ModernMenu'))).
export const THEMES = {
  default: DefaultMenu,
};

export const resolveTheme = (key) => THEMES[key] ?? THEMES.default;
